import { Spin as AntSpin } from 'antd';
import React from 'react';

import s from './Spin.module.less';

type Size = 'small' | 'large' | 'default' | undefined;

interface Props {
  size?: Size;
  style?: React.CSSProperties;
}

const Spin: React.FC<Props> = ({ size = 'default', style }) => (
  <div className={s.root}>
    <AntSpin size={size} style={style} />
  </div>
);

export default Spin;
